import React from "react";
import { Routes, Route } from "react-router-dom";
import { Box, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import PersonalDetailsForm from "../homepage/Authentication/PersonalDetailsForm";
import EducationJobForm from "../homepage/Authentication/EducationJobForm";
import FamilyDetailsForm from "../homepage/Authentication/FamilyDetailsForm";
import PartnerPreferencesForm from "../homepage/Authentication/PartnerPrefrencesForm";
import MatrimonyReviewPage from "../homepage/Authentication/MatrimonyReviewPage";
import Dashbord from '../homepage/userdashbord/dashbordcommonroutes';
import Profileroutes from "../homepage/userdashbord/Profileroutes";
import UploadImage from "../homepage/userdashbord/UploadImage";
import SuggestedProfile from "../homepage/userdashbord/SuggestedProfile";
import SearchProfile from "../homepage/userdashbord/SearchProfile";
import Profiles from "../homepage/userdashbord/Profiles";
import Interests from "../homepage/userdashbord/Interests";
import RazorpayButton from "../homepage/userdashbord/Razor-Pay/razor-pay";
import About from '../homepage/userdashbord/About'
import Contact from "../homepage/userdashbord/Contact";
import AdvancedSearch from "../homepage/userdashbord/AdvancedSearch";
import Carrers from "../homepage/userdashbord/Carrers";
const PageWrapper = styled(Box)(({ theme }) => ({
	// backgroundColor: "#FDF9F4",
	// minHeight: "100vh",
	padding: theme.spacing(0),// give the padding 4
	[theme.breakpoints.down("sm")]: {
		padding: theme.spacing(0), // give the padding 2
	},
}));

const ContentContainer = styled(Container)(({ theme }) => ({
	[theme.breakpoints.up("lg")]: {
		maxWidth: "100%",// give the width 90%
	},
	[theme.breakpoints.down("md")]: {
		padding: theme.spacing(0),// give the padding 2 
		// i just remove this padding way because  in this routes you just assign breake points it will be depends on screen design thats way i just remove that 
	},
}));

const ProfileLayout = () => {
	const userType = sessionStorage.getItem("userType")
	return (
		<PageWrapper>
			{/* <Header /> */}
			<ContentContainer maxWidth={false}>
				<Routes>
					<Route path="personal-details" element={<PersonalDetailsForm />} /> 
					<Route path="education" element={<EducationJobForm />} />
					<Route path="family" element={<FamilyDetailsForm />} />
					<Route
						path="partner-preferences"
						element={<PartnerPreferencesForm />}
					/>
					<Route path="review" element={<MatrimonyReviewPage/>} />
					{!userType && <Route path='/DetaliesDashbord' element={<Dashbord/>}/>}
					 <Route path='/ProfileView' element={<Profileroutes/>}/>
					{!userType && <Route path="/UploadImage" element={<UploadImage/>}/>}
					{!userType && <Route path="/SuggestedProfiles" element={<SuggestedProfile/>}/>}
					{!userType && <Route path="/SearchProfile" element={<SearchProfile/>}/>}
					{!userType && <Route path="/Profile" element={<Profiles/>}/>}
					{!userType && <Route path="/Interest" element={<Interests/>}/>}
					{!userType && <Route path="/payment" element = {<RazorpayButton/>}/>}
					{!userType && <Route path="/About" element={<About/>}/>}
					{!userType && <Route path="/Contact" element={<Contact/>}/>}
					{!userType && <Route path="/Careers" element={<Carrers/>}/>}
					{!userType && <Route path="/AdvancedSearch" element={<AdvancedSearch/>}/>}

				</Routes>
			</ContentContainer>
		</PageWrapper>
	);
};

export default ProfileLayout;
